import { Icon, IconButton } from '@zillow/constellation-10';
import { IconDeleteOutline } from '@zillow/constellation-icons';
import IconButtonTooltip from '../IconButtonTooltip';

type DeleteAttachmentsButtonProps = {
  isDisabled: boolean;
  onClick(): void;
};

export default function DeleteAttachmentsButton({ isDisabled, onClick }: DeleteAttachmentsButtonProps) {
  return (
    <IconButtonTooltip
      content="Delete attachments"
      trigger={
        <IconButton
          shape="circle"
          tone="brand"
          disabled={isDisabled}
          icon={<Icon render={<IconDeleteOutline />} />}
          size="sm"
          title="Delete attachments"
          css={{ margin: 'tighter' }}
          onClick={onClick}
        />
      }
    />
  );
}
